/**
 * What a TikTok player shows while another player on the page holds the single slot (playerSlot.ts): the video's
 * thumbnail (or a dark fill) with a play button that takes the slot back.
 */
import { Play } from 'lucide-react';
import { cn } from '@/components/ui/utils';

export function TikTokPausedPoster({ thumbnailUrl, label, onPlay, className }: {
  thumbnailUrl?: string | null;
  /** Accessible name of the play button, e.g. "Play TikTok video 1 using Night Drive". */
  label: string;
  onPlay: () => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onPlay}
      aria-label={label}
      className={cn('group relative flex h-full w-full items-center justify-center overflow-hidden bg-black outline-none focus-visible:ring-2 focus-visible:ring-[#be43ff]/60', className)}
    >
      {thumbnailUrl && <img src={thumbnailUrl} alt="" className="absolute inset-0 h-full w-full object-cover opacity-80" />}
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-black/55 text-white backdrop-blur-sm transition-transform group-hover:scale-105">
        <Play className="ml-0.5 h-6 w-6" fill="currentColor" aria-hidden />
      </span>
    </button>
  );
}
